import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL + '/Charge';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const chargeService = {
  getCharges: async (pageNumber = 1, size = 10, searchTerms = '') => {
    try {
      const response = await api.get('/Pagination', {
        params: { PageNumber: pageNumber, Size: size, searchTerms },
      });
      const data = response.data;
      return {
        data: data.list || [],
        totalItems: data.total || 0,
        totalPages: data.maxPage || 0,
        currentPage: data.page || 1,
        pageSize: data.pageSize || size,
      };
    } catch (error) {
      console.error('Error fetching charges:', error);
      throw new Error(`Failed to fetch charges: ${error.message}`);
    }
  },

  getCharge: async (id) => {
    const response = await api.get(`/${id}`);
    return response.data;
  },

  createCharge: async (chargeData) => {
    const payload = {
      id: 0,
      typeCharge: chargeData.typeCharge,
      date: chargeData.date,
      values: Number(chargeData.values),
      productId: chargeData.productId ? Number(chargeData.productId) : null,
      plateformId: chargeData.plateformId ? Number(chargeData.plateformId) : null,
    };
    const response = await api.post('', payload);
    return response.data;
  },

  updateCharge: async (id, chargeData) => {
    const payload = {
      id: Number(id),
      typeCharge: chargeData.typeCharge,
      date: chargeData.date,
      values: Number(chargeData.values),
      productId: chargeData.productId ? Number(chargeData.productId) : null,
      plateformId: chargeData.plateformId ? Number(chargeData.plateformId) : null,
    };
    const response = await api.put('', payload);
    return response.data;
  },

  deleteCharge: async (id) => {
    const response = await api.delete(`/${id}`);
    return response.data;
  },

  bulkDeleteCharges: async (ids) => {
    const results = await Promise.all(ids.map((id) => api.delete(`/${id}`)));
    return results;
  },
};
